const permissions = {
  ADMINISTRATOR_ACCESS_ALL: "Quản lý_{split}_Toàn bộ",
  ACCESS_ALL_DATA: "Truy cập_{split}_Danh sách",

  INTERNAL_INFORMATION: "Truy cập thông tin nội bộ_{split}_",

  CONTENT_ACCESS: "Quản lý nội dung_{split}_Truy cập",
  CONTENT_VIEW: "Quản lý nội dung_{split}_Xem",
  CONTENT_ADD: "Quản lý nội dung_{split}_Thêm mới",
  CONTENT_EDIT: "Quản lý nội dung_{split}_Sửa",
  CONTENT_DELETE: "Quản lý nội dung_{split}_Xóa",

  DOCUMENT_ACCESS: "Quản lý văn bản_{split}_Truy cập",
  DOCUMENT_VIEW: "Quản lý văn bản_{split}_Xem",
  DOCUMENT_ADD: "Quản lý văn bản_{split}_Thêm mới",
  DOCUMENT_EDIT: "Quản lý văn bản_{split}_Sửa",
  DOCUMENT_DELETE: "Quản lý văn bản_{split}_Xóa",

  PUBLICATIONS_ACCESS: "Quản lý ấn phẩm_{split}_Truy cập",
  PUBLICATIONS_VIEW: "Quản lý ấn phẩm_{split}_Xem",
  PUBLICATIONS_ADD: "Quản lý ấn phẩm_{split}_Thêm mới",
  PUBLICATIONS_EDIT: "Quản lý ấn phẩm_{split}_Sửa",
  PUBLICATIONS_DELETE: "Quản lý ấn phẩm_{split}_Xóa",

  YEARBOOK_ACCESS: "Quản lý niên giám_{split}_Truy cập",
  YEARBOOK_VIEW: "Quản lý niên giám_{split}_Xem",
  YEARBOOK_ADD: "Quản lý niên giám_{split}_Thêm mới",
  YEARBOOK_EDIT: "Quản lý niên giám_{split}_Sửa",
  YEARBOOK_DELETE: "Quản lý niên giám_{split}_Xóa",

  STATISTICS_ACCESS: "Quản lý số liệu thống kê_{split}_Truy cập",
  STATISTICS_VIEW: "Quản lý số liệu thống kê_{split}_Xem",
  STATISTICS_ADD: "Quản lý số liệu thống kê_{split}_Thêm mới",
  STATISTICS_EDIT: "Quản lý số liệu thống kê_{split}_Sửa",
  STATISTICS_DELETE: "Quản lý số liệu thống kê_{split}_Xóa",

  INTERNAL_OPERATION_ACCESS: "Quản lý điều hành nội bộ_{split}_Truy cập",
  INTERNAL_OPERATION_VIEW: "Quản lý điều hành nội bộ_{split}_Xem",
  INTERNAL_OPERATION_ADD: "Quản lý điều hành nội bộ_{split}_Thêm mới",
  INTERNAL_OPERATION_EDIT: "Quản lý điều hành nội bộ_{split}_Sửa",
  INTERNAL_OPERATION_DELETE: "Quản lý điều hành nội bộ_{split}_Xóa",

  STATISTICAL_SERVICE_ACCESS: "Quản lý dịch vụ thống kê_{split}_Truy cập",
  STATISTICAL_SERVICE_VIEW: "Quản lý dịch vụ thống kê_{split}_Xem",
  STATISTICAL_SERVICE_ADD: "Quản lý dịch vụ thống kê_{split}_Thêm mới",
  STATISTICAL_SERVICE_EDIT: "Quản lý dịch vụ thống kê_{split}_Sửa",
  STATISTICAL_SERVICE_DELETE: "Quản lý dịch vụ thống kê_{split}_Xóa",

  SURVEY_ACCESS: "Quản lý khảo sát_{split}_Truy cập",
  SURVEY_VIEW: "Quản lý khảo sát_{split}_Xem",
  SURVEY_ADD: "Quản lý khảo sát_{split}_Thêm mới",
  SURVEY_EDIT: "Quản lý khảo sát_{split}_Sửa",
  SURVEY_DELETE: "Quản lý khảo sát_{split}_Xóa",

  FEEDBACK_ACCESS: "Quản lý góp ý_{split}_Truy cập",
  FEEDBACK_VIEW: "Quản lý góp ý_{split}_Xem",
  FEEDBACK_ADD: "Quản lý góp ý_{split}_Thêm mới",
  FEEDBACK_EDIT: "Quản lý góp ý_{split}_Sửa",
  FEEDBACK_DELETE: "Quản lý góp ý_{split}_Xóa",

  DISPLAY_ACCESS: "Quản lý hiển thị_{split}_Truy cập",
  DISPLAY_VIEW: "Quản lý hiển thị_{split}_Xem",
  DISPLAY_ADD: "Quản lý hiển thị_{split}_Thêm mới",
  DISPLAY_EDIT: "Quản lý hiển thị_{split}_Sửa",
  DISPLAY_DELETE: "Quản lý hiển thị_{split}_Xóa",

  NOTIFICATION_ACCESS: "Quản lý thông báo_{split}_Truy cập",
  NOTIFICATION_VIEW: "Quản lý thông báo_{split}_Xem",
  NOTIFICATION_ADD: "Quản lý thông báo_{split}_Thêm mới",
  NOTIFICATION_EDIT: "Quản lý thông báo_{split}_Sửa",
  NOTIFICATION_DELETE: "Quản lý thông báo_{split}_Xóa",

  COLLECT_INFORMATION_ACCESS: "Thu thập thông tin_{split}_Truy cập",
  COLLECT_INFORMATION_VIEW: "Thu thập thông tin_{split}_Xem",
  COLLECT_INFORMATION_ADD: "Thu thập thông tin_{split}_Thêm mới",
  COLLECT_INFORMATION_EDIT: "Thu thập thông tin_{split}_Sửa",
  COLLECT_INFORMATION_DELETE: "Thu thập thông tin_{split}_Xóa",

  GIS_ACCESS: "Khai thác dữ liệu bản đồ_{split}_Truy cập",
  GIS_VIEW: "Khai thác dữ liệu bản đồ_{split}_Xem",
  GIS_ADD: "Khai thác dữ liệu bản đồ_{split}_Thêm mới",
  GIS_EDIT: "Khai thác dữ liệu bản đồ_{split}_Sửa",
  GIS_DELETE: "Khai thác dữ liệu bản đồ_{split}_Xóa",

  MANAGER_AND_ROLE_ACCESS: "Quản lý người dùng và quyền_{split}_Truy cập",
  MANAGER_AND_ROLE_VIEW: "Quản lý người dùng và quyền_{split}_Xem",
  MANAGER_AND_ROLE_ADD: "Quản lý người dùng và quyền_{split}_Thêm mới",
  MANAGER_AND_ROLE_EDIT: "Quản lý người dùng và quyền_{split}_Sửa",
  MANAGER_AND_ROLE_DELETE: "Quản lý người dùng và quyền_{split}_Xóa",

  CONFIGURATION_MANAGER_EDIT: "Quản lý cấu hình_{split}_Sửa",

  SUBSITE_CONFIG_ACCESS: "Quản lý cấu hình website_{split}_Truy cập",
  SUBSITE_CONFIG_VIEW: "Quản lý cấu hình website_{split}_Xem",
  SUBSITE_CONFIG_ADD: "Quản lý cấu hình website_{split}_Thêm mới",
  SUBSITE_CONFIG_EDIT: "Quản lý cấu hình website_{split}_Sửa",
  SUBSITE_CONFIG_DELETE: "Quản lý cấu hình website_{split}_Xóa",

  ACTIVITY_LOG_MANAGER_ACCESS: "Quản lý nhật ký hoạt động_{split}_Truy cập",
  ACTIVITY_LOG_MANAGER_VIEW: "Quản lý nhật ký hoạt động_{split}_Xem",
  ACTIVITY_LOG_MANAGER_EXPORT: "Quản lý nhật ký hoạt động_{split}_Xuất dữ liệu",
};

const ROlE_ADMINISTRATOR = "Administrator";
export { permissions, ROlE_ADMINISTRATOR };
